import * as React from "react";
import styled from "styled-components";

const LayoutChildren = styled.div`
  width: 100%;
  min-height: 80vh;
  position: relative;
`;

// Top-level layout for navigation and content.
export interface LayoutProps {
  navigation?: JSX.Element;
  className?: string;
}
export const Layout: React.StatelessComponent<LayoutProps> = ({
  navigation,
  children
}) => (
  <div>
    {navigation}
    <LayoutChildren>{children}</LayoutChildren>
  </div>
);
